export default "__VITE_ASSET__D5u$f$xj__"